export const MARKETING_CHANNEL = [
  { value: 'recommendation', label: 'Rekomendasi' },
  { value: 'event', label: 'Acara' },
  { value: 'advertisement', label: 'Iklan' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'linkedin', label: 'Linkedin' },
  { value: 'twitter', label: 'Twitter' },
]